import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type ProjectScopePillFragment = { __typename?: 'Project', id: string, name: string, imageUrl?: string | null };

export const ProjectScopePill = /*#__PURE__*/ gql`
    fragment ProjectScopePill on Project {
  id
  name
  imageUrl
}
    ` as unknown as DocumentNode<ProjectScopePillFragment, unknown>;

        

        
export const useProjectScopePillFragment = (
  input: string | Omit<UseFragmentOptions<ProjectScopePillFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Project' } };
    return input;
  })();

  return useFragment<ProjectScopePillFragment>({
    fragment: ProjectScopePill,
    fragmentName: 'ProjectScopePill',
    ...options,
  });
};
  
        